import { getMessage, setup } from '@tcc/i18n';
import { setupI18n } from '@tcc/field-guide';
import { setupI18n as setupCropUiTranslations } from '@tcc/crop-ui';
import { setupI18n as setupPluginUiTranslations } from '@tcc/plugin-ui';
import * as FDS from '@tcc/fds';
import { BootNames } from '../types/bootNames';
import englishFile from '../i18n/en.json';

const FDS_KEY_PATTERN = /^fds[.-]/;

const translateFDSString = (
  key: string,
  fallback?: string,
  options?: Record<string, unknown>,
) => {
  if (!FDS_KEY_PATTERN.test(key)) {
    return fallback || key;
  }
  const message = getMessage(key, options);
  return message || fallback || key;
};

const setupFDSStrings = () => {
  const {setupFDSTranslations} = (FDS as unknown as {
    setupFDSTranslations?: (translate?: typeof translateFDSString) => void;
  });

  setupFDSTranslations?.(translateFDSString);
};

export const i18n = {
  name: BootNames.i18n,
  installer: async () => {
    await Promise.all([
      setup({
        project: 'field-view',
        englishFile,
      }),
      setupI18n(),
      setupCropUiTranslations(),
      setupPluginUiTranslations(),
    ]);

    setupFDSStrings();
  },
};
